import React from 'react';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';

export type IntroductionCardType = {
    pc: string;
    pad?: string;
    h5?: string;
    desc: string;
    userName: string;
    headImg: string;
};

interface IntroductionCardsProps {
    className?: string;
    list: IntroductionCardType[];
}

const IntroductionCards: React.FC<IntroductionCardsProps> = ({ className, list }) => {
    return (
        <Swiper className={classNames('ef-introduction-cards', className, styles.TheComp)} slidesPerView={'auto'}>
            {list.map((item, idx) => (
                <SwiperSlide className="ef-introduction-card" key={idx}>
                    <EfImg className="ef-introduction-card-img" pc={item.pc} pad={item.pad} h5={item.h5} />
                    <div className="ef-introduction-card-info">
                        <div className="ef-introduction-card-desc">{item.desc}</div>
                        <div className="ef-introduction-card-user">
                            <EfImg className="ef-introduction-card-user-img" pc={item.headImg} />
                            <div className="ef-introduction-card-user-name">{item.userName}</div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};
export default IntroductionCards;
